export default {
  loadCompany (state, payload) {
    state.company = {
      tradingName: payload.fantasia,
      document: payload.documento,
      phone: payload.ddd + payload.telefone,
      email: payload.email,
      logo: payload.logo,
      description: payload.descricaoNegocio,
      site: payload.url,
      zipCode: payload.cep,
      address: payload.endereco,
      addressNumber: payload.nro,
      complement: payload.complemento,
      neighborhood: payload.bairro,
      state: payload.uf,
      city: payload.cidade,
      categories: payload.categorias,
      needSchedule: payload.needSchedule,
      customTime: payload.customTime,
      weekDayStart: payload.weekDayStart,
      weekDayEnd: payload.weekDayEnd,
      weekDayInterval: payload.weekDayInterval,
      weekDayCapacity: payload.weekDayCapacity,
      sundayStart: payload.sundayStart,
      sundayEnd: payload.sundayEnd,
      sundayInterval: payload.sundayInterval,
      sundayCapacity: payload.sundayCapacity,
      mondayStart: payload.mondayStart,
      mondayEnd: payload.mondayEnd,
      mondayInterval: payload.mondayInterval,
      mondayCapacity: payload.mondayCapacity,
      tuesdayStart: payload.tuesdayStart,
      tuesdayEnd: payload.tuesdayEnd,
      tuesdayInterval: payload.tuesdayInterval,
      tuesdayCapacity: payload.tuesdayCapacity,
      wednesdayStart: payload.wednesdayStart,
      wednesdayEnd: payload.wednesdayEnd,
      wednesdayInterval: payload.wednesdayInterval,
      wednesdayCapacity: payload.wednesdayCapacity,
      thursdayStart: payload.thursdayStart,
      thursdayEnd: payload.thursdayEnd,
      thursdayInterval: payload.thursdayInterval,
      thursdayCapacity: payload.thursdayCapacity,
      fridayStart: payload.fridayStart,
      fridayEnd: payload.fridayEnd,
      fridayInterval: payload.fridayInterval,
      fridayCapacity: payload.fridayCapacity,
      saturdayStart: payload.saturdayStart,
      saturdayEnd: payload.saturdayEnd,
      saturdayInterval: payload.saturdayInterval,
      saturdayCapacity: payload.saturdayCapacity
    }
  },
  unshelfLogo (state, value) {
    state.logoNotSent = ''
  },
  updateLogo (state, value) {
    state.company.logo = value
  },
  updateTradingName (state, value) {
    state.company.tradingName = value
  },
  updateDocument (state, value) {
    state.company.document = value
  },
  updatePhone (state, value) {
    state.company.phone = value
  },
  updateEmail (state, value) {
    state.company.email = value
  },
  updateDescription (state, value) {
    state.company.description = value
  },
  updateSite (state, value) {
    state.company.site = value
  },
  updateZipCode (state, value) {
    state.company.zipCode = value
  },
  updateAddress (state, value) {
    state.company.address = value
  },
  updateAddressNumber (state, value) {
    state.company.addressNumber = value
  },
  updateComplement (state, value) {
    state.company.complement = value
  },
  updateNeighborhood (state, value) {
    state.company.neighborhood = value
  },
  updateState (state, value) {
    state.company.state = value
  },
  updateCity (state, value) {
    state.company.city = value
  },
  loadingCompany (state, value) {
    state.loadingCompany = value
  },
  loadingZipCode (state, value) {
    state.loadingZipCode = value
  },
  toggleWaitingApproval (state, value) {
    state.waitingApproval = value
  },
  resetEmpresa (state) {
    state.company = {
      tradingName: '',
      document: '',
      phone: '',
      email: '',
      logo: '',
      description: '',
      site: '',
      zipCode: '',
      address: '',
      addressNumber: '',
      complement: '',
      neighborhood: '',
      state: '',
      city: '',
      categories: [],
      needSchedule: false,
      customTime: false,
      weekDayStart: '',
      weekDayEnd: '',
      weekDayInterval: '',
      weekDayCapacity: 0,
      sundayStart: '',
      sundayEnd: '',
      sundayInterval: '',
      sundayCapacity: 0,
      mondayStart: '',
      mondayEnd: '',
      mondayInterval: '',
      mondayCapacity: 0,
      tuesdayStart: '',
      tuesdayEnd: '',
      tuesdayInterval: '',
      tuesdayCapacity: 0,
      wednesdayStart: '',
      wednesdayEnd: '',
      wednesdayInterval: '',
      wednesdayCapacity: 0,
      thursdayStart: '',
      thursdayEnd: '',
      thursdayInterval: '',
      thursdayCapacity: 0,
      fridayStart: '',
      fridayEnd: '',
      fridayInterval: '',
      fridayCapacity: 0,
      saturdayStart: '',
      saturdayEnd: '',
      saturdayInterval: '',
      saturdayCapacity: 0
    }
  },
  loadEvaluations (state, payload) {
    state.totalItems = payload.totalItens
    state.currentPage = payload.paginaAtual
    state.totalPages = payload.totalPaginas
    state.itemsPerPage = payload.itensPorPagina
    state.evaluations = payload.list
    state.paginaInicial = payload.paginaInicial
    state.paginaFinal = payload.paginaFinal
  },
  toggleEvaluationModal (state, value) {
    state.evaluationModal = value
  },
  loadUsers (state, payload) {
    state.totalItems = payload.totalItens
    state.currentPage = payload.paginaAtual
    state.totalPages = payload.totalPaginas
    state.itemsPerPage = payload.itensPorPagina
    state.users = payload.list
    state.paginaInicial = payload.paginaInicial
    state.paginaFinal = payload.paginaFinal
  },
  nextPage (state) {
    state.currentPage ++
  },
  prevPage (state) {
    state.currentPage --
  },
  changeItemsPerPage (state, value) {
    state.itemsPerPage = value
  },
  resetPage (state) {
    state.currentPage = 1
  },
  selectUser (state, payload) {
    state.selectedUser.id = payload.id
    state.selectedUser.nome = payload.nome
    state.selectedUser.login = payload.login
    state.selectedUser.telefone = payload.telefone
    state.selectedUser.email = payload.email
    state.selectedUser.departamento = payload.departamento
    state.selectedUser.active = payload.active
    state.selectedUser.senha = payload.senha
  },
  appendNewUser (state, payload) {
    state.users.push(payload)
  },
  updateRegisteredUsers (state, payload) {
    state.users = state.users.map((elem) => {
      return elem.id === state.selectedUser.id ? state.selectedUser : elem
    })
  },
  newUser (state) {
    state.selectedUser = {
      id: 0,
      nome: '',
      login: '',
      telefone: '',
      email: '',
      departamento: '',
      active: true,
      senha: ''
    }
  },
  toggleUserActive (state) {
    state.selectedUser.active = !state.selectedUser.active
  },
  resetUser (state) {
    state.selectedUser = {}
    state.registeredItems = []
  },
  toggleUserModal (state, value) {
    state.userModal = value
  },
  updateUserName (state, value) {
    state.selectedUser.nome = value
  },
  updateUserLogin (state, value) {
    state.selectedUser.login = value
  },
  updateUserPassword (state, value) {
    state.selectedUser.senha = value
  },
  updateUserEmail (state, value) {
    state.selectedUser.email = value
  },
  updateUserPhone (state, value) {
    state.selectedUser.telefone = value
  },
  updateUserDepartment (state, value) {
    state.selectedUser.departamento = value
  },
  updateWeekdayStart (state, value) {
    state.company.weekDayStart = value
  },
  updateWeekdayEnd (state, value) {
    state.company.weekDayEnd = value
  },
  updateWeekdayInterval (state, value) {
    state.company.weekDayInterval = value
  },
  updateWeekdayCapacity (state, value) {
    state.company.weekDayCapacity = value
  },
  updateSundayStart (state, value) {
    state.company.sundayStart = value
  },
  updateSundayEnd (state, value) {
    state.company.sundayEnd = value
  },
  updateSundayInterval (state, value) {
    state.company.sundayInterval = value
  },
  updateSundayCapacity (state, value) {
    state.company.sundayCapacity = value
  },
  updateMondayStart (state, value) {
    state.company.mondayStart = value
  },
  updateMondayEnd (state, value) {
    state.company.mondayEnd = value
  },
  updateMondayInterval (state, value) {
    state.company.mondayInterval = value
  },
  updateMondayCapacity (state, value) {
    state.company.mondayCapacity = value
  },
  updateTuesdayStart (state, value) {
    state.company.tuesdayStart = value
  },
  updateTuesdayEnd (state, value) {
    state.company.tuesdayEnd = value
  },
  updateTuesdayInterval (state, value) {
    state.company.tuesdayInterval = value
  },
  updateTuesdayCapacity (state, value) {
    state.company.tuesdayCapacity = value
  },
  updateWednesdayStart (state, value) {
    state.company.wednesdayStart = value
  },
  updateWednesdayEnd (state, value) {
    state.company.wednesdayEnd = value
  },
  updateWednesdayInterval (state, value) {
    state.company.wednesdayInterval = value
  },
  updateWednesdayCapacity (state, value) {
    state.company.wednesdayCapacity = value
  },
  updateThursdayStart (state, value) {
    state.company.thursdayStart = value
  },
  updateThursdayEnd (state, value) {
    state.company.thursdayEnd = value
  },
  updateThursdayInterval (state, value) {
    state.company.thursdayInterval = value
  },
  updateThursdayCapacity (state, value) {
    state.company.thursdayCapacity = value
  },
  updateFridayStart (state, value) {
    state.company.fridayStart = value
  },
  updateFridayEnd (state, value) {
    state.company.fridayEnd = value
  },
  updateFridayInterval (state, value) {
    state.company.fridayInterval = value
  },
  updateFridayCapacity (state, value) {
    state.company.fridayCapacity = value
  },
  updateSaturdayStart (state, value) {
    state.company.saturdayStart = value
  },
  updateSaturdayEnd (state, value) {
    state.company.saturdayEnd = value
  },
  updateSaturdayInterval (state, value) {
    state.company.saturdayInterval = value
  },
  updateSaturdayCapacity (state, value) {
    state.company.saturdayCapacity = value
  },
  toggleNeedSchedule (state) {
    state.company.needSchedule = !state.company.needSchedule
  },
  toggleCustomTime (state) {
    state.company.customTime = !state.company.customTime
  },
  selectAvaliacao (state, value) {
    for (let i = 0; i < state.evaluations.length; i++) {
      if (state.evaluations[i].id === value) {
        state.selectedAvaliacao = state.evaluations[i]
        state.evaluationModal = true
        break
      }
    }
  },
  updateResposta (state, value) {
    state.selectedAvaliacao.resposta = value
  }
}




// WEBPACK FOOTER //
// ./src/store/empresa/mutations.js